import { Component } from '@angular/core';
import {APP_BASE_HREF, NgIf} from "@angular/common";
import {environment} from "../environments/environment.prod";
import {ActivatedRoute, Params, RouterOutlet, Router} from "@angular/router";
import {HostService} from "./services/host.service";

@Component({
  selector: 'app-root',
  standalone: true,
  providers: [{ provide: APP_BASE_HREF, useValue: '/publications' }],
  imports: [NgIf, RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.sass'
})
export class AppComponent {
  protected isDevelopment: boolean = !environment.production;

  constructor(private route: ActivatedRoute, private router: Router, private hostService: HostService) {
    this.route.queryParams.subscribe((params: Params) => {
      if (params['host']) {
        this.hostService.host = params['host'];
      }
      if (params['publications_path']) {
        this.router.navigate([`/${params['publications_path']}`]);
      }
    });
  }
}
